<script setup lang="ts">
defineProps({
  size: null
})

const checked = defineModel<boolean>("checked", { required: true })
</script>

<template>
  <div class="checkbox" :class="[size]">
    <div
      class="inner"
      :class="{ checked }"
    >
      <icon-action
        size="xs"
        type="check"
        :class="{ hidden: !checked }"
      />
    </div>
    <input
      v-model="checked"
      type="checkbox"
    >
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.checkbox
  @apply relative
  @apply text-[#{global-t-default}]
  @apply cursor-pointer
  &.sm
    @apply w-[#{$global-w-icon-sm}] h-[#{$global-w-icon-sm}]
    .inner
      @apply rounded-[#{$menu-br-action-icon}]
  &.xs
    @apply w-[#{$global-w-icon-xs}] h-[#{$global-w-icon-xs}]
    .inner
      @apply rounded-[#{$menu-br-action-icon}]

.inner
  @apply w-full h-full flex items-center justify-center
  &:not(.checked)
    @apply bg-[#{$page-properties-bg-property-secondary}]
  &.checked
    @apply bg-[#{$global-blue-primary}]

input
  @apply absolute w-full h-full top-0 left-0 opacity-0 cursor-pointer
</style>
